function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#636363;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M2.7,22.8c0-0.4,0.3-0.8,0.8-0.8h18c0.4,0,0.8,0.3,0.8,0.8c0,0.4-0.3,0.8-0.8,0.8h-18 C3.1,23.5,2.7,23.2,2.7,22.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M2.7,10.1c0-1,0.8-1.8,1.8-1.8h1.6c1,0,1.8,0.8,1.8,1.8v8.6c0,1-0.8,1.8-1.8,1.8H4.5c-1,0-1.8-0.8-1.8-1.8 V10.1z M4.5,9.9c-0.1,0-0.3,0.1-0.3,0.3v8.6c0,0.1,0.1,0.3,0.3,0.3h1.6c0.1,0,0.3-0.1,0.3-0.3v-8.6c0-0.1-0.1-0.3-0.3-0.3H4.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M9.9,6.9c0-1,0.8-1.8,1.8-1.8h1.6c1,0,1.8,0.8,1.8,1.8v11.8c0,1-0.8,1.8-1.8,1.8h-1.6c-1,0-1.8-0.8-1.8-1.8 V6.9z M11.7,6.7c-0.1,0-0.3,0.1-0.3,0.3v11.8c0,0.1,0.1,0.3,0.3,0.3h1.6c0.1,0,0.3-0.1,0.3-0.3V6.9c0-0.1-0.1-0.3-0.3-0.3H11.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M17.2,3.8c0-1,0.8-1.8,1.8-1.8h1.6c1,0,1.8,0.8,1.8,1.8v15c0,1-0.8,1.8-1.8,1.8h-1.6c-1,0-1.8-0.8-1.8-1.8V3.8 z M18.9,3.5c-0.1,0-0.3,0.1-0.3,0.3v15c0,0.1,0.1,0.3,0.3,0.3h1.6c0.1,0,0.3-0.1,0.3-0.3v-15c0-0.1-0.1-0.3-0.3-0.3H18.9z"
}));

var SvgAnalyticsIconSmallGrey = function SvgAnalyticsIconSmallGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 25,
    height: 25,
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnalyticsIconSmallGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/analytics-icon-small-grey.0c421206.svg";
export { ForwardRef as ReactComponent };